.signUpForm {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
}
.signUpForm .buttonSection button {
  width: 100%;
}
.signUpForm .marketingConsentText {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-content-default);
}

.signUpForm .marketingConsentTextError {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-error);
}

.errorMessage {
  margin-top: var(--cxy-spacing-1);
  color: var(--cxy-color-content-error);
}

.agreeTermsError {
  color: var(--cxy-color-error);
  font-size: var(--cxy-fontSize-xs);
  margin-top: 0;
}

.termsContainer {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-1);
}

.termsCheckboxRow {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-1);
}

.termsLink {
  font-size: var(--cxy-fontSize-xs);
  text-decoration: underline !important;
  color: var(--cxy-color-white);
}

.termsLinkError {
  font-size: var(--cxy-fontSize-xs);
  color: var(--cxy-color-error);
}

.termsText {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-content-default);
}
.termsText a {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  text-decoration: underline;
  color: var(--cxy-color-content-default);
}

/* WhoScored theme override */
[data-fpsm-theme='whoscored'] .signUpForm .buttonSection button {
  color: var(--cxy-color-black-700);
  text-transform: uppercase;
}
